
















import { defineComponent } from '@vue/composition-api';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';

export default defineComponent({
	components: {
		CtaButton,
	},
	props: {
		editLabel: {
			type: String,
			default: 'edit-button',
		},
		isEditable: Boolean,
	},
});
